import {
  Box,
  Button,
  ButtonBase,
  CircularProgress,
  Icon,
  IconButton,
  Link,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import CoChipSmall from '../../../shared/components/ui/CoChipSmall';
import UserAvatar from '../../../shared/components/ui/UserAvatar';
import { ConferenceContext } from '../../../shared/context/ConferenceContext';
import {
  downloadVisitorsCSV,
  infoList,
} from '../../../shared/utils/DataFormat';

const ecardStyles = makeStyles((theme) => ({
  buttonHolder: {
    alignSelf: 'flex-end',
  },
  ecardList: {
    '& > *:nth-child(even)': {
      backgroundColor: theme.palette.background.shadedown_10,
      borderBottomWidth: 1,
      borderBottomColor: theme.palette.background.default,
      borderBottomStyle: 'solid',
    },
  },
  ecardButton: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  ecardMessage: {
    whiteSpace: 'pre-wrap',
  },
  delete: {
    float: 'right',
    opacity: 0.5,
    '&:hover': {
      opacity: 1,
    },
  },
  //   bg: {
  //     backgroundColor: '#77777733',
  //     borderRadius: 5,
  //     height: '100%',
  //   },
  //   field: {
  //     backgroundColor: '#444444',
  //     color: '#ffffff',
  //   },
}));

export const ReceiveECards = React.memo((props) => {
  const classes = ecardStyles();
  const [message, setMessage] = useState('');
  const [ecards, setEcards] = useState([]);
  const [showEcardList, toggleEcardList] = useState(false);
  const [hasLeftCard, setHasLeft] = useState(false);
  const [loading, setLoading] = useState(true);
  const { openUserPopup } = useContext(ConferenceContext); // Hämta Context
  const data = props.data || {};

  const loadECardList = () => {
    axios
      .get(`/api/visitor/entities/${props.entityId}/ecards`)
      .then((response) => {
        setEcards(response.data);
      });
  };
  useEffect(() => {
    axios
      .get(`/api/visitor/entities/${props.entityId}/ecard`)
      .then((response) => {
        setHasLeft(response.data.hasLeft);
        setLoading(false);
      });
    if (props.isHost) {
      loadECardList();
    }
  }, []);

  const submitEcard = () => {
    setLoading(true);
    axios
      .post(`/api/visitor/entities/${props.entityId}/ecard`, { message })
      .then(() => {
        setHasLeft(true);
        setLoading(false);
      });
  };

  const deleteECard = (visitorId) => {
    axios
      .put(`/api/visitor/entities/${props.entityId}/removeecard`, { visitorId })
      .then(() => {
        loadECardList();
      });
  };

  return loading ? (
    <CircularProgress />
  ) : (
    <>
      <Box display="flex" alignItems="center">
        <Box flexGrow={1}>
          <Typography variant="body1" gutterBottom>
            {data.description || `Leave your E-Card and we'll contact you.`}
          </Typography>
          {hasLeftCard ? (
            <Box>{data.thanks || `Thanks! We'll be in touch!`}</Box>
          ) : (
            <>
              {data.addmessage && (
                <TextField
                  onChange={(e) => setMessage(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  multiline
                  placeholder={data.message || ''}
                  variant="outlined"
                  //   label="Message"
                />
              )}
            </>
          )}
        </Box>
        {!hasLeftCard && (
          <Box p={1} className={classes.buttonHolder}>
            <Button
              color="primary"
              onClick={submitEcard}
              startIcon={<Icon>contact_mail</Icon>}
            >
              {data.button || 'Leave E-Card'}
            </Button>
          </Box>
        )}
      </Box>
      {props.isHost && (
        <Box pt={1}>
          <Button size="small" onClick={() => toggleEcardList(!showEcardList)}>
            {showEcardList ? 'Hide' : 'Show'} contacts ({ecards.length})
          </Button>
          {showEcardList && (
            <Box pt={1} className={classes.ecardList}>
              {ecards.map((ecard) => (
                <Box key={ecard.id} p={1}>
                  <IconButton
                    className={classes.delete}
                    onClick={() => deleteECard(ecard.id)}
                  >
                    <Icon>delete</Icon>
                  </IconButton>
                  <ButtonBase
                    onClick={() => openUserPopup(ecard)}
                    className={classes.ecardButton}
                  >
                    <Box display="flex" alignItems="center">
                      <Box pr={1}>
                        <UserAvatar user={ecard} size="small" />
                      </Box>
                      <Box>
                        {infoList([
                          ecard.full_name,
                          ecard.title,
                          ecard.company,
                          ecard.location_city,
                        ])}
                      </Box>
                    </Box>
                  </ButtonBase>
                  <Box>
                    {ecard.tags
                      .map((tag) => (
                        <CoChipSmall
                          size="smaller"
                          key={tag.id}
                          tagtype={tag.type}
                          label={tag.title}
                        />
                      ))
                      .reduce((r, a) => r.concat(', ', a), [])
                      .slice(1)}
                  </Box>
                  {ecard.data && ecard.data.message && (
                    <Box pt={1} className={classes.ecardMessage}>
                      {ecard.data && ecard.data.message}
                    </Box>
                  )}
                  <Box>
                    <Link href={`mailto: ${ecard.email}`}>{ecard.email}</Link>
                  </Box>
                </Box>
              ))}
              <br />
              <Button
                size="small"
                color="primary"
                startIcon={<Icon>download</Icon>}
                onClick={() => downloadVisitorsCSV(ecards)}
              >
                Download list
              </Button>
            </Box>
          )}
        </Box>
      )}
    </>
  );
});

ReceiveECards.displayName = 'ReceiveECards';
